import { useNavigate } from "react-router-dom";
import { Avatar } from "@/shared/ui";
import { PLATFORM_LABELS } from "./mockData";
import type { SimilarBlogger, PlatformKey } from "./mockData";

const AVATAR_GRADS: Record<PlatformKey, [string, string]> = {
  tg:   ["#9FE1CB", "#085041"],
  vk:   ["#B5D4F4", "#0C447C"],
  yt:   ["#F5C4B3", "#712B13"],
  dzen: ["#E8E8E8", "#444"],
  tt:   ["#E0E0E5", "#1A1D22"],
  lk:   ["#FFE8D5", "#7A2200"],
  max:  ["#E9DEFF", "#3D179A"],
};

export function SimilarBloggers({ bloggers, context }: {
  bloggers: SimilarBlogger[];
  context: "catalog" | "campaign";
}) {
  const navigate = useNavigate();
  if (!bloggers.length) return null;
  return (
    <section className="mt-8">
      <div className="text-[11px] font-display font-bold uppercase tracking-[0.16em] text-ink-40 mb-2">
        Похожие блогеры
      </div>
      <div className="grid grid-cols-3 gap-2">
        {bloggers.map((b) => (
          <button
            key={b.id}
            onClick={() => navigate(`/blogger/${b.id}${context === "campaign" ? "?ctx=campaign" : ""}`)}
            className="flex items-center gap-2.5 p-[10px] rounded-lg text-left transition-colors hover:border-[#639922]"
            style={{ border: "0.5px solid rgba(28,28,28,0.12)" }}
          >
            <Avatar name={b.name} size={30} grad={AVATAR_GRADS[b.platform] ?? ["#BFF93F", "#1C1C1C"]} />
            <div className="min-w-0">
              <div className="font-display font-[500] text-[12px] truncate">{b.name}</div>
              <div className="text-[10px] text-ink-40 truncate">
                {PLATFORM_LABELS[b.platform]} · {b.category}
              </div>
              <div className="text-[11px] font-mono text-ink-60">
                CPV {b.cpv} ₽ · ER {b.er}%
              </div>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
